import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom";
import UtilClass from "api_ref/UtilClass";
import LayoutLandingPage from "components/layout/LayoutLandingPageV3";
import Notices from "components/mockup/Notices";
import Attribute from "components/mockup/Attribute";
import KeyFeatures from "components/mockup/KeyFeatures";
import Security from "components/mockup/Security";
import PackageMockup from "components/mockup/PackageMockup";
import ApiConection from "api_ref/ApiConection";
import FeatureMockup from "components/mockup/FeatureMockup";
import Banner2 from "components/mockup/Banner2";
import ParticlesFireworks from "components/mockup/ParticlesFireworks";
import { useState } from "react";
import moment from "moment/moment";
import YouTubeVideo from "components/mockup/YouTubeVideo";
import { use } from "react";

export default function Home() {
    const util = new UtilClass();
    const [notice, setnotice] = useState(false)
    const [fireworks,setFireworks] = useState(false)
    
    useEffect(() => {
    window.location.href = process.env.REACT_APP_WORDPRESS_URL;
        return null;
}, [])

    // useEffect(()=>{
        // window.setTimeout(()=>{
        //     // 1. อ่านและแยกวิเคราะห์พารามิเตอร์ URL
        //     const urlParams = new URLSearchParams(window.location.search);
        //     const targetSection = urlParams.get('section');

        //     // 2. เลื่อนหน้าเว็บไปยังส่วนที่ต้องการ
        //     if (targetSection == 'package') {
        //         const yOffset = -150;
        //         const targetElement = document.getElementById('div_package_mockup');
        //         const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

        //         if (targetElement) {
                    
        //             // ใช้ Element.scrollIntoView() เพื่อเลื่อนไปยัง targetElement
        //             //targetElement.scrollIntoView({ behavior: 'smooth' });
        //             window.scrollTo({ top: y, behavior: 'smooth' });
        //         }
        //     }
        // },500)
    // },[])
    
    const navigate = useNavigate();

    return (
        <LayoutLandingPage  >
            <Banner2 />
            <YouTubeVideo/>
            <FeatureMockup />
            <Attribute />
            <KeyFeatures />
            <Security />
            <PackageMockup />
        </LayoutLandingPage>
    );
}